import { render, staticRenderFns } from "./sales-card.vue?vue&type=template&id=8b78b1e8"
import script from "./sales-card.vue?vue&type=script&lang=js"
export * from "./sales-card.vue?vue&type=script&lang=js"
import style0 from "./sales-card.vue?vue&type=style&index=0&id=8b78b1e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports